import { render, staticRenderFns } from "./newsCate.vue?vue&type=template&id=1466ddbd&scoped=true"
import script from "./newsCate.vue?vue&type=script&lang=js"
export * from "./newsCate.vue?vue&type=script&lang=js"
import style0 from "./newsCate.vue?vue&type=style&index=0&id=1466ddbd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1466ddbd",
  null
  
)

export default component.exports